import { api } from './config';

export interface OrderItem {
  productId: string;
  quantity: number;
}

export interface OrderProduct {
  id: number;
  ordered_quantity: number;
  quantity: number;
  rate: number;
  amount: number;
  product: {
    id: number;
    name: string;
    // Add more fields from product if needed
  };
}

export interface Order {
  id: number;
  created_at: string;
  status: string;
  final_amount: number;
  products: OrderProduct[];
  // Add more fields from API response if needed
}

export interface PlaceOrderPayload {
  domain: string;
  products: {
    product_id: number;
    quantity: number;
    rate: number;
  }[];
}

export const placeOrder = async (payload: PlaceOrderPayload): Promise<Order> => {
  // Instead of authorization, send mobile number in headers
  const mobile = localStorage.getItem('mobile');
  if (!mobile) throw new Error('No mobile number found. Please login again.');
  const domain = window.location.hostname;
  const response = await api.post('/api/v1/storefront/storefronts/create-order/', {
    ...payload,
    domain,
    x_domain: domain,
    'x-app-name': 'retailer',
    mobile,
  });
  return response.data;
};

export const getOrderHistory = async (): Promise<any[]> => {
  const mobile = localStorage.getItem('mobile');
  if (!mobile) throw new Error('No mobile number found. Please login again.');
  const response = await api.get('/api/v1/storefront/storefronts/get_orders_by_mobile/', {
    params: { mobile },
  });
  // Return the array of orders (results)
  return response.data.results;
}
